import style
  from '@src/pages/TerminationAgreement/TerminationAgreement.module.scss'
import { FieldFormik } from '@src/components/common/FieldFormik/FieldFormik'
import { Button } from '@src/components/Button/Button'
import { Info } from '@src/components/PersonalInfo/Info'
import { useState } from 'react'

export const SecondStep = () => {
  const [checked, setCheckedField] = useState(false)
  const setChecked = () => {
    setCheckedField(!checked)
  }
  return (
    <div className={style.stepThirdContainer}>
      <div className={style.step}>
        Шаг 2/2
      </div>
      <h2 className={style.mainTitle}>
        Введите номер телефона
      </h2>
      <div className={style.description}>
        Специалист будет информировать Вас о статусе заявки по Вашему номеру телефона.
      </div>
      <div className={style.phoneBox}>
        <FieldFormik
          className={style.inputSize}
          label="Введите номер телефона"
          name="phone"
          placeholder="+375 (ХХ) ХХХ ХХ ХХ"
          mask="+{375} (00) 000-00-00"
        />
        <div className={style.btnBlock2}>
          <Button disabled={!checked} htmlType="submit" className={style.btnSize}>Отправить</Button>
        </div>
      </div>
      <Info checkbox checked={checked} onchange={setChecked} name="Отправить" className={style.fieldSize} />
    </div>
  )
}
